import React, { Component } from 'react';

import { withFirebase } from '../Firebase';

import { TextField, Button } from '@material-ui/core'

const INITIAL_STATE = {
  passwordOne: '',
  passwordTwo: '',
  error: null,
};

class PasswordChangeForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    const { passwordOne } = this.state;

    this.props.firebase
      .doPasswordUpdate(passwordOne)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
      })
      .catch(error => {
        this.setState({ error });
      });

    event.preventDefault();

    document.getElementById("changePassword").style.display = "none"
    document.getElementById("btnChangePassword").style.display = "block"

  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { passwordOne, passwordTwo, error } = this.state;

    const isInvalid =
      passwordOne !== passwordTwo || passwordOne === '';

    return (
      <div id="changePassword" style={{display: "none"}}>
      <form onSubmit={this.onSubmit}>
        <TextField
          name="passwordOne"
          value={passwordOne}
          onChange={this.onChange}
          type="password"
          placeholder="New Password"
          style={{margin: 20, marginLeft: 0, width: 250}}
          />
        <br/>
        <TextField
            name="passwordTwo"
            value={passwordTwo}
            onChange={this.onChange}
            type="password"
            placeholder="Confirm New Password"
            style={{margin: 20, marginLeft: 0, width: 250}}
          />
        <br/>
          <Button size="small" style={{backgroundColor: "orange", margin: 10, marginLeft: 0}}
            onClick={() => {
              document.getElementById("changePassword").style.display = "none"
              document.getElementById("btnChangePassword").style.display = "block"
            }}>
            Cancel
          </Button>
        <Button size="small" disabled={isInvalid} type="submit" style={{backgroundColor: "#9BD238", margin: 10, marginLeft: 0}}>
          Reset My Password
        </Button>

        {error && <p>{error.message}</p>}
      </form>
      </div>
    );
  }
}

export default withFirebase(PasswordChangeForm);
